import {

  FC,

  useState,

  useEffect,

  createContext,

  useContext,

  useRef,

  Dispatch,

  SetStateAction,

} from 'react'

import {LayoutSplashScreen} from '../../../../_metronic/layout/core'

import {AuthModel, UserModel} from './_models'

import * as authHelper from './AuthHelpers'

import {getUserByToken} from './_requests'

import {WithChildren} from '../../../../_metronic/helpers'

import { useQuery } from 'react-query'



export type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'session_expired' | 'server_unavailable'



type AuthContextProps = {

  auth: AuthModel | undefined

  saveAuth: (auth: AuthModel | undefined) => void

  currentUser: UserModel | undefined

  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>

  authStatus: AuthStatus

  setAuthStatus: Dispatch<SetStateAction<AuthStatus>>

  logout: () => void

  verifyAuth: () => void

}



const initAuthContextPropsState = {

  auth: authHelper.getAuth(),

  saveAuth: () => {},

  currentUser: undefined,

  setCurrentUser: () => {},

  authStatus: 'idle' as AuthStatus,

  setAuthStatus: () => {},

  logout: () => {},

  verifyAuth: () => {},

}



const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)



const useAuth = () => {

  return useContext(AuthContext)

}



const AuthProvider: FC<WithChildren> = ({children}) => {

  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())

  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()

  const [authStatus, setAuthStatus] = useState<AuthStatus>('idle')

  

  const saveAuth = (auth: AuthModel | undefined) => {

    setAuth(auth)

    if (auth) {

      authHelper.setAuth(auth)

      setAuthStatus('loading')

    } else {

      authHelper.removeAuth()

      setAuthStatus((current) => (current === 'session_expired' ? 'session_expired' : 'idle'))

    }

  }



  const logout = () => {

    saveAuth(undefined)

    setCurrentUser(undefined)

    document.dispatchEvent(new Event('user:logout'))

  }



  const verifyAuth = () => {

    const token = auth?.api_token

    if (token) {

      getUserByToken(token)

    }

  }





  return (

    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, authStatus, setAuthStatus, logout, verifyAuth}}>

      {children}

    </AuthContext.Provider>

  )

}



const AuthInit: FC<WithChildren> = ({children}) => {

  const {auth, logout, setCurrentUser, setAuthStatus} = useAuth()

  const [showSplashScreen, setShowSplashScreen] = useState(true)

  const didRequest = useRef(false);

  const token = auth?.api_token

  const hasToken = Boolean(token)



  useQuery(

    ['auth-user', token],

    async () => {

      const {data} = await getUserByToken(token as string)

      return data

    },

    {

      enabled: hasToken,

      refetchOnWindowFocus: false,

      refetchIntervalInBackground: true,



      retry: (failureCount, error: any) => {

        if (authHelper.isSessionExpiredError(error)) return false

        if (authHelper.isAuthError(error)) return false

        return failureCount < 2

      },



      refetchInterval: (_data, query) => {

        const error = query.state.error as any

        if (authHelper.isSessionExpiredError(error)) return false

        if (authHelper.isAuthError(error)) return false

        if (query.state.data) return false

        return 5000

      },



      onSuccess: (user) => {

        setCurrentUser(user)

        setAuthStatus('authenticated')

        setShowSplashScreen(false)

      },



      onError: (error: any) => {

        if (authHelper.isSessionExpiredError(error)) {

          authHelper.markSessionExpired()

          setAuthStatus('session_expired')

          if (!didRequest.current) {

            logout()

          }

        } else if (authHelper.isAuthError(error)) {

          if (!didRequest.current) {

            logout()

          }

        } else {

          setAuthStatus('server_unavailable')

        }

        setShowSplashScreen(false)

      },

    }

  )



  useEffect(() => {

    if (!hasToken) {

      logout()

      setShowSplashScreen(false)

    }

  }, [hasToken, logout])



  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>

}



export {AuthProvider, AuthInit, useAuth}

